import React, { useState } from "react";
import axios, { Axios } from "axios";
import { useLocation } from "react-router";
import axiosInstance from "../HSAxios";
import { Card, CardBody, CardText, Button } from "react-bootstrap";
import "../index.css";
import PaymentStatusModal from "./PaymentStatusModal";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const cardArr = [
  {
    tile: "Basic",
    month: "3",
    amount: "300",
    original: "350",
  },
  {
    tile: "Saving Plan",
    month: "6",
    amount: "500",
    original: "600",
  },
  {
    tile: "Super Saving Plan",
    month: "12",
    amount: "900",
    original: "1200",
  },
];

const PaymentPage = () => {
  const [msg, setMsg] = useState("");
  const [paymentDetails, setPaymentDetails] = useState({});
  const [error, setError] = useState("");
  const [subsType, setSubsType] = useState("0");
  const [isSelected, setIsSelected] = useState(null);
  const [amount, setAmount] = useState(null);
  const [walletError, setWalletError] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState("null");
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [btnTitle, setBtnTitle] = useState("");
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const location = useLocation();

  const { origin } = location.state || {};
  // const location = useLocation();

  // const owner = location.state;
  const [owner, setOwner] = useState({});
  useEffect(() => {
    axiosInstance.get("api/hostel/owner").then((response) => {
      if (response.status) {
        setOwner(response.data[0]);
      }
    });
  }, []);

  const loadRazorPayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleCheckout = async (e) => {
    setBtnLoading(true);
    if (amount === null) {
      setError("Please Select plan type!");
      return;
    }
    const isScriptLoaded = await loadRazorPayScript();

    if (!isScriptLoaded) {
      alert("There was an error loading the Razorpay script.");
      return;
    }

    // Make an API call to your server to create an order
    const orderResponse = await axiosInstance.post("api/create-order", {
      amount: amount,
      // currency: "INR",
    });

    const options = {
      key: "rzp_live_T8xfY9mOXjEUC8",
      // key: "rzp_live_Ot0cCn3gT5g7tX",
      // amount: "50",
      currency: "INR",
      name: "Hostel Duniya",
      description: "Test Transaction",
      image: `${process.env.PUBLIC_URL}/hosteladminlogo.png`,
      order_id: orderResponse.order_id, // Use the `order_id` from the server response
      handler: function (response) {
        console.log(response.razorpay_payment_id);
        console.log(response.razorpay_order_id);
        console.log(response.razorpay_signature);
        axiosInstance
          .post("api/verify-payment", {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            subscription: subsType,
            amount: amount,
          })
          .then((response) => {
            console.log(response);
            setShowModal(true);
            setPaymentSuccess(true);

            setTitle("Payment Successful");

            setBtnTitle("Done");
            if (origin === "leads") {
              setMsg(
                "Your payment was processed successfully! Redirecting to leads page..."
              );
              setTimeout(() => navigate("/leads"), 3000);
            } else {
              setMsg(
                "Your payment was processed successfully! Redirecting to profile page..."
              );
              setTimeout(() => navigate("/profile"), 3000);
            }
            // setPaymentSuccessfull("Payment is successful");
          })
          .finally(() => {
            setBtnLoading(false);
          });
      },
      modal: {
        ondismiss: function () {
          setBtnLoading(false);
          // Razorpay popup was closed by the user
          console.log("Payment popup closed by the user");
          // alert("Payment was not completed. Please try again.");
          // Perform actions like redirecting to a failure page or re-enabling buttons
          setTitle("Payment Failed");
          setShowModal(true);
          setPaymentSuccess(false);
          setBtnTitle("Retry");
          // console.log("payment failed!", response.error.metadata.order_id);

          setMsg("Oops! Something went wrong. Please try again.");
        },
      },
      prefill: {
        name: owner.name,
        // email: owner.email_id,
        contact: owner.phone_number,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", function (response) {
      setBtnLoading(false);
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
      setTitle("Payment Failed");
      setShowModal(true);
      setPaymentSuccess(false);
      setBtnTitle("Retry");
      console.log("payment failed!", response.error.metadata.order_id);

      setMsg("Oops! Something went wrong. Please try again.");
    });
    rzp.open();

    e.preventDefault();
  };
  const handleSubsSelection = (idx) => {
    setIsSelected(idx);
    setSubsType("1");
    setAmount(cardArr[idx].amount);
    setWalletError("");
    setError("");
  };
  const handleWalletAmountChange = (e) => {
    setIsSelected(null);
    setSubsType("0");
    if (e.target.value > 0 && e.target.value % 10 === 0) {
      setAmount(e.target.value);
      setWalletError("");
    } else {
      setWalletError("Amount is not multiple of 10");
      setAmount(null);
    }
    setError("");
  };
  console.log(amount);
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="container mt-2">
      {error && <p className="text-danger fw-bold">{error}</p>}
      {/* {paymentSuccessful && (
        <div class="alert alert-success" role="alert">
          Payment is successful!
        </div>
      )} */}
      <PaymentStatusModal
        show={showModal}
        onClose={closeModal}
        isSuccess={paymentSuccess}
        msg={msg}
        title={title}
        btnTitle={btnTitle}
        handler={closeModal}
      />
      <div className="col">
        <h4 className="mb-4" style={{ color: "#760B0B", fontWeight: "700", fontSize: "28px" }}>
          PLAN TYPE
        </h4>
        <div className="row mb-2">
          <h4 className="text-black text-start">Subscription Type</h4>
          {cardArr.map((card, idx) => {
            return (
              <div className="custom-subs-class ">
                {/* <div className="custom-subs-class">
                  <span className="content-class">
                    {card.amount} for {card.month} months
                  </span>
                </div> */}
                <input
                  type="radio"
                  className="input-field-class"
                  id={`${idx}`}
                  checked={isSelected === idx}
                  onChange={() => handleSubsSelection(idx)}
                ></input>
                <label for={`${idx}`} className="lbl">
                  <div className="marker"></div>
                  <div className="content mx-2">
                    <div className="title">
                      &#8377; {Math.floor(card.amount / card.month)}/month*
                    </div>
                    <div className="subtext">
                      <span style={{ textDecoration: "line-through" }}>
                        &#8377;{card.original}
                      </span>
                      &nbsp; &#8377;{card.amount} For {card.month} Months
                    </div>
                  </div>
                </label>
              </div>
            );
          })}
        </div>
        <div className="row">
          <h4 className="text-black text-start">Wallet Amount Type</h4>
          <div className="col text-black mb-2">
            <label for="wallet" className="wallet-lbl">
              Enter Amount (in multiples of 10)
            </label>

            <input
              type="text"
              id="wallet"
              min={0}
              className="wallet-inp"
              value={subsType === "0" ? amount : ""}
              onChange={handleWalletAmountChange}
            ></input>
          </div>
          {walletError && <p className="text-danger">{walletError}</p>}
        </div>
      </div>

      <button
        type="button"
        onClick={handleCheckout}
        className="btn btn-success fw-semibold px-5 py-3 mt-4"
        style={{
          borderRadius: "12px",
          fontSize: "18px",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 15px rgba(40, 167, 69, 0.3)",
        }}
        disabled={btnLoading}
        onMouseEnter={(e) => {
          if (!btnLoading) {
            e.target.style.transform = "translateY(-3px)";
            e.target.style.boxShadow = "0 6px 20px rgba(40, 167, 69, 0.4)";
          }
        }}
        onMouseLeave={(e) => {
          if (!btnLoading) {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
          }
        }}
      >
        {btnLoading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Processing Payment...
          </>
        ) : (
          "Make Payment"
        )}
      </button>
    </div>
  );
};

export default PaymentPage;
